/**
 * @generated SignedSource<<4b3b33a154a36caffee526e00b171889>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type InitiateInvoicePaymentInput = {
  invoiceIdentifier: string;
};
export type InitiateInvoicePaymentDialogMutation$variables = {
  input: InitiateInvoicePaymentInput;
};
export type InitiateInvoicePaymentDialogMutation$data = {
  readonly initiateInvoicePayment: {
    readonly id: string;
    readonly updatedAt: any | null | undefined;
  };
};
export type InitiateInvoicePaymentDialogMutation = {
  response: InitiateInvoicePaymentDialogMutation$data;
  variables: InitiateInvoicePaymentDialogMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "Invoice",
    "kind": "LinkedField",
    "name": "initiateInvoicePayment",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "updatedAt",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "InitiateInvoicePaymentDialogMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "InitiateInvoicePaymentDialogMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "02aaa2e5446a4448b2a3400bd39c69c3",
    "id": null,
    "metadata": {},
    "name": "InitiateInvoicePaymentDialogMutation",
    "operationKind": "mutation",
    "text": "mutation InitiateInvoicePaymentDialogMutation(\n  $input: InitiateInvoicePaymentInput!\n) {\n  initiateInvoicePayment(input: $input) {\n    id\n    updatedAt\n  }\n}\n"
  }
};
})();

(node as any).hash = "eb2a04f2a8487cec2ae16ff1add062e9";

export default node;
